import React from 'react';
import styled from 'styled-components';
import Zoom from "../../../assets/images/icon/Zoom";
import EditIcon from "../../../assets/images/icon/EditIcon";

const ListButtonItem = ({children, onClick=()=>{}, text = ""}) => {
return(
    <ListButton
        onClick={() => {
          onClick()
        }}
    >
      <span>{text || ""}</span>
      {children}
    </ListButton>
)

}
export default ListButtonItem;

const ListButton = styled.div`
    background: #333;
    width: 80px;
    height: 26px;
    border-radius: 5px;
    overflow: hidden;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    border: solid 1px #333;
    //&:hover{
    //    background: #fff;
    //    span{
    //        color: #333!important;   
    //    }
    //}
    transition: all 0.2s;
    &:hover{
        background: #fff;
        span{
            color: #333;
        }
        svg{
            display: block;
            path{
                fill: #333;
            }
        }
    }
    svg{
        display: block;
        path{
            fill: #fff;
        }
    }
    @media screen and (max-width: 768px) {
        position: absolute;
        right: 0px;
    }
    span {
        display: flex;
        height: 100%;
        align-items: center;
        color: #fff;
        box-shadow: none;
        border-radius: 5px;
        font-family: var(--fontFamilyRegular);
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
    }
`;
